import { styled } from "@mui/material/styles";

export const Lines = styled("span")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
